import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import io from 'socket.io-client';
import { jwtDecode } from 'jwt-decode';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(10);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
const [selectedOrder, setSelectedOrder] = useState(null);
const [orderStates, setOrderStates] = useState({});
const [exportedOrders, setExportedOrders] = useState(new Set());
const [showOnlyNotExported, setShowOnlyNotExported] = useState(false);
const [searchOrderId, setSearchOrderId] = useState('');
const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');


////////////////////// get token user and pass //////////////////
const token = localStorage.getItem("token")
    const decodedToken = jwtDecode(token);

    const username = decodedToken.username;
     const name = decodedToken.name;

const mydb = username.slice(0, 3);

      
//////////////////////



// Parse URL query parameter for searchOrderId on mount
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const orderIdParam = params.get('searchOrderId');
  if (orderIdParam) {
    setSearchOrderId(orderIdParam);
  }
}, []);

const handleExportInvoice = async () => {
  try {
    const inStockTotal = selectedOrder.items
      .filter(item => (item.order_state || orderStates[item.id] || 'pending') === 'instock')
      .reduce((sum, item) => sum + item.total_price, 0);

    // Collect all notes from items that are in stock
    const inStockNotes = selectedOrder.items
      .filter(item => (item.order_state || orderStates[item.id] || 'pending') === 'instock')
      .map(item => item.note)
      .filter(note => note) // Remove null/undefined notes
      .join(' | '); // Join multiple notes with a separator

    const invoiceData = {
      orderid: selectedOrder.order_id,
      amount: inStockTotal,
      client_name: selectedOrder.client_name,
      client_id: selectedOrder.client_id,
      tel1: selectedOrder.client_tel1,
      tel2: selectedOrder.client_tel2,
      address: selectedOrder.client_address,
      paymentmethod: selectedOrder.paymentmethod || 'pending',
      date: new Date().toISOString() // Add today's date in ISO format
    };

    console.log('Sending invoice data:', invoiceData); // Add logging

    const response = await fetch('/invoices?mydb='+mydb, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(invoiceData),
    });

    if (!response.ok) {
      throw new Error('Failed to create invoice');
    }

    toast.success('Invoice created successfully!', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    // Update the exported orders list to reflect the new invoice
    setExportedOrders(prev => new Set([...prev, selectedOrder.order_id]));

    closeDetailsModal();
  } catch (error) {
    console.error('Error creating invoice:', error);
    toast.error('Failed to create invoice', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

  const handleExportPDF = () => {
    if (!selectedOrder) {
      toast.error('No order selected for PDF export', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const doc = new jsPDF();

    // Add header with company name on left and contact info on right with border and modern style
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;
    const headerHeight = 30; // Increased height to accommodate logo

    // Draw header background rectangle with a modern gradient-like color
    doc.setFillColor(33, 150, 243); // Blue color
    doc.rect(0, 0, pageWidth, headerHeight, 'F');

    // Add logo image
    const logoPath = '/img/22.png';
    //doc.addImage(logoPath, 'PNG', margin, 2, 16, 16); // Add logo at top left

    // Draw bottom border line for header
    doc.setDrawColor(255, 255, 255);
    doc.setLineWidth(1);
    doc.line(0, headerHeight, pageWidth, headerHeight);

    // Company name on left in white bold font
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.text("a2Zskincarelb", margin + 20, 14); // Moved right to accommodate logo

    // Contact info on right in white normal font
    const contactInfo = "Contact:  | 78 - 920826";
    const contactInfoWidth = doc.getTextWidth(contactInfo);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(contactInfo, pageWidth - margin - contactInfoWidth, 24); // Moved down for better spacing

    // Reset font and color for body text
    doc.setFontSize(18);
    doc.setTextColor(40, 40, 40);
    doc.setFont('helvetica', 'normal');
    doc.text(`Order #${selectedOrder.order_id} Details`, margin, headerHeight + 14);

    doc.setFontSize(12);
    doc.text(`Customer: ${selectedOrder.client_name}`, margin, headerHeight + 24);
    doc.text(`Phone 1: ${selectedOrder.client_tel1 || 'N/A'}`, margin, headerHeight + 32);
    doc.text(`Phone 2: ${selectedOrder.client_tel2 || 'N/A'}`, margin, headerHeight + 40);
    doc.text(`Address: ${selectedOrder.client_address || 'N/A'}`, margin, headerHeight + 48);
    doc.text(`Date: ${formatDate(selectedOrder.date)}`, margin, headerHeight + 56);
    const inStockTotal = selectedOrder.items
      .filter(item => (item.order_state || orderStates[item.id] || 'pending') === 'instock')
      .reduce((sum, item) => sum + item.total_price, 0);
    doc.text(`Total Amount: ${formatCurrency(inStockTotal)}`, margin, headerHeight + 64);
    doc.text(`Payment Method: ${selectedOrder.paymentmethod || 'N/A'}`, margin, headerHeight + 72);

    // Prepare table data
    const tableColumn = ["Item ID", "Item Name", "Quantity", "Status", "Unit Price", "Total Price", "Note"];
    const tableRows = [];

    selectedOrder.items.forEach(item => {
      const itemData = [
        item.item_id,
        item.item_name,
        item.quantity.toString(),
        item.order_state || orderStates[item.id] || 'pending',
        formatCurrency(item.unit_price),
        formatCurrency(item.total_price),
        item.note || '-'
      ];
      tableRows.push(itemData);
    });

    autoTable(doc, {
      startY: headerHeight + 84,
      head: [tableColumn],
      body: tableRows,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [33, 150, 243], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 248, 255] },
      margin: { left: margin, right: margin },
      tableLineColor: [33, 150, 243],
      tableLineWidth: 0.5,
    });

    doc.save(`Order_${selectedOrder.order_id}.pdf`);
  };

  // New function to generate PDF blob and send via WhatsApp
  const handleExportPDFAndSendWhatsApp = () => {
    if (!selectedOrder) {
      toast.error('No order selected for PDF export', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    // Prepare text message with order details
    const order = selectedOrder;
    const inStockTotal = order.items
      .filter(item => (item.order_state || orderStates[item.id] || 'pending') === 'instock')
      .reduce((sum, item) => sum + item.total_price, 0);

    let messageText = `Order #${order.order_id} Details:\n`;
    messageText += `Customer: ${order.client_name}\n`;
    messageText += `Phone 1: ${order.client_tel1 || 'N/A'}\n`;
    messageText += `Phone 2: ${order.client_tel2 || 'N/A'}\n`;
    messageText += `Address: ${order.client_address || 'N/A'}\n`;
    messageText += `Date: ${formatDate(order.date)}\n`;
    messageText += `Total Amount: ${formatCurrency(inStockTotal)}\n`;
    messageText += `Payment Method: ${order.paymentmethod || 'N/A'}\n\n`;
    messageText += `Items:\n`;

    order.items.forEach(item => {
      const status = item.order_state || orderStates[item.id] || 'pending';
      messageText += `- ${item.item_name} (ID: ${item.item_id}), Qty: ${item.quantity}, Status: ${status}, Unit Price: ${formatCurrency(item.unit_price)}, Total: ${formatCurrency(item.total_price)}, Note: ${item.note || '-'}\n`;
    });

    // Generate PDF and get URL (simulate saving PDF to server or cloud)
    const doc = new jsPDF();

    // Add header with company name on left and contact info on right with border and modern style
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;
    const headerHeight = 30; // Increased height to accommodate logo

    // Draw header background rectangle with a modern gradient-like color
    doc.setFillColor(33, 150, 243); // Blue color
    doc.rect(0, 0, pageWidth, headerHeight, 'F');

    // Add logo image
    const logoPath = '/img/22.png';
    doc.addImage(logoPath, 'PNG', margin, 2, 16, 16); // Add logo at top left

    // Draw bottom border line for header
    doc.setDrawColor(255, 255, 255);
    doc.setLineWidth(1);
    doc.line(0, headerHeight, pageWidth, headerHeight);

    // Company name on left in white bold font
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.text("A2ZSkincare-", margin + 20, 14); // Moved right to accommodate logo

    // Contact info on right in white normal font
    const contactInfo = "Contact:  | +961 70 682 069";
    const contactInfoWidth = doc.getTextWidth(contactInfo);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(contactInfo, pageWidth - margin - contactInfoWidth, 24); // Moved down for better spacing

    // Reset font and color for body text
    doc.setFontSize(18);
    doc.setTextColor(40, 40, 40);
    doc.setFont('helvetica', 'normal');
    doc.text(`Order #${order.order_id} Details`, margin, headerHeight + 14);

    doc.setFontSize(12);
    doc.text(`Customer: ${order.client_name}`, margin, headerHeight + 24);
    doc.text(`Phone 1: ${order.client_tel1 || 'N/A'}`, margin, headerHeight + 32);
    doc.text(`Phone 2: ${order.client_tel2 || 'N/A'}`, margin, headerHeight + 40);
    doc.text(`Address: ${order.client_address || 'N/A'}`, margin, headerHeight + 48);
    doc.text(`Date: ${formatDate(order.date)}`, margin, headerHeight + 56);
    doc.text(`Total Amount: ${formatCurrency(inStockTotal)}`, margin, headerHeight + 64);
    doc.text(`Payment Method: ${order.paymentmethod || 'N/A'}`, margin, headerHeight + 72);

    // Prepare table data
    const tableColumn = ["Item ID", "Item Name", "Quantity", "Status", "Unit Price", "Total Price", "Note"];
    const tableRows = [];

    order.items.forEach(item => {
      const itemData = [
        item.item_id,
        item.item_name,
        item.quantity.toString(),
        item.order_state || orderStates[item.id] || 'pending',
        formatCurrency(item.unit_price),
        formatCurrency(item.total_price),
        item.note || '-'
      ];
      tableRows.push(itemData);
    });

    autoTable(doc, {
      startY: headerHeight + 84,
      head: [tableColumn],
      body: tableRows,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [33, 150, 243], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 248, 255] },
      margin: { left: margin, right: margin },
      tableLineColor: [33, 150, 243],
      tableLineWidth: 0.5,
    });

    // Instead of saving, get the PDF as base64 string
    const pdfBase64 = doc.output('datauristring');

    // Simulate PDF URL (in real app, upload PDF and get URL)
    const pdfUrl = `https://example.com/invoices/Order_${order.order_id}.pdf`;

    // Append PDF URL to message text
   // const fullMessage = encodeURIComponent(`${messageText}\nPDF Invoice: ${pdfUrl}`);

    const fullMessage = encodeURIComponent(`${messageText}\n`);

    const phone = order.client_tel1.replace(/\D/g, ''); // Remove non-digit chars
    const whatsappUrl = `https://wa.me/${phone}?text=${fullMessage}`;

    window.open(whatsappUrl, '_blank');

    toast.info('WhatsApp Web opened with order details and PDF link.', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

const handleOrderStateChange = async (id, newState) => {
  try {
    // Update database
    const response = await fetch(`/orders/${id}/state?mydb=`+mydb, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ order_state: newState }),
    });

    if (!response.ok) {
      throw new Error('Failed to update order state');
    }

    // Update local state using database ID
    setOrderStates(prev => ({
      ...prev,
      [id]: newState
    }));
    
    // Update order_state in the items array of the modal
    if (selectedOrder) {
      const updatedItems = selectedOrder.items.map(item => 
        item.id === id 
          ? { ...item, order_state: newState }
          : item
      );
      setSelectedOrder({
        ...selectedOrder,
        items: updatedItems
      });
    }

    // Update the main orders list to reflect the change
    setOrders(prevOrders => 
      prevOrders.map(order => 
        order.id === id 
          ? { ...order, order_state: newState }
          : order
      )
    );

    toast.success('Order state updated successfully', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  } catch (error) {
    console.error('Error updating order state:', error);
    toast.error('Failed to update order state', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

  useEffect(() => {
    fetchOrders();
    fetchExportedOrders();

    // Initialize WebSocket connection
    const socket = io('');

    // Listen for order state updates
    socket.on('orderStateUpdated', (data) => {
      console.log('Received order state update:', data);
      
      // Update local state
      setOrderStates(prev => ({
        ...prev,
        [data.id]: data.order_state
      }));
      
      // Update orders list
      setOrders(prevOrders => 
        prevOrders.map(order => 
          order.id === data.id 
            ? { ...order, order_state: data.order_state }
            : order
        )
      );

      // Update selected order if it's currently open
      setSelectedOrder(prevSelected => {
        if (prevSelected) {
          const updatedItems = prevSelected.items.map(item => 
            item.id === data.id 
              ? { ...item, order_state: data.order_state }
              : item
          );
          return {
            ...prevSelected,
            items: updatedItems
          };
        }
        return prevSelected;
      });

      // Show toast notification
      toast.info(`Order item state updated to: ${data.order_state}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });

    // Listen for invoice creation events
    socket.on('invoiceCreated', (data) => {
      console.log('Received invoice creation:', data);
      
      // Update exported orders list
      setExportedOrders(prev => new Set([...prev, parseInt(data.orderid)]));

      // Show toast notification
      toast.success(`Invoice created for Order #${data.orderid}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });

    // Cleanup on component unmount
    return () => {
      socket.disconnect();
    };
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await fetch('/orders?mydb='+mydb);
      if (!response.ok) {
        throw new Error('Failed to fetch orders');
      }
      const data = await response.json();
      // Sort orders by date in descending order
      const sortedOrders = data.sort((a, b) => new Date(b.date) - new Date(a.date));
      
      // Map the orders to include all necessary fields
      const processedOrders = sortedOrders.map(order => ({
        ...order,
        client_tel1: order.client_tel1,
        client_tel2: order.client_tel2,
        client_address: order.address && order.city ? `${order.address}, ${order.city}` : order.address || order.city || null,
               paymentmethod: order.paymentmethod,

      }));
      
      setOrders(processedOrders);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const fetchExportedOrders = async () => {
    try {
      const response = await fetch('/myinvoice?mydb='+mydb);
      if (response.ok) {
        const invoices = await response.json();
        // Convert orderid to number to match order_id type
        const exportedOrderIds = new Set(invoices.map(invoice => parseInt(invoice.orderid)));
        setExportedOrders(exportedOrderIds);
      }
    } catch (err) {
      console.error('Error fetching invoices:', err);
    }
  };

  const openDeleteModal = (orderId) => {
    setOrderToDelete(orderId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setOrderToDelete(null);
    setShowDeleteModal(false);
  };

  const openDetailsModal = (group) => {
    // Initialize items with order_state if not present
    const itemsWithState = group.items.map(item => ({
      ...item,
      order_state: item.order_state || 'pending'
    }));
    
    setSelectedOrder({
      ...group,
      items: itemsWithState
    });
    setShowDetailsModal(true);
    
    // Initialize order states from items using database ID
    const initialStates = {};
    itemsWithState.forEach((item) => {
      initialStates[item.id] = item.order_state || 'pending';
    });
    setOrderStates(initialStates);
  };

  const closeDetailsModal = () => {
    setSelectedOrder(null);
    setShowDetailsModal(false);
  };

  const handleDelete = async () => {
    if (!orderToDelete) return;
    try {
      // First, try to delete any associated invoices
      const invoiceResponse = await fetch(`/invoices/order/${orderToDelete}?mydb=`+mydb, {
        method: 'DELETE',
      });
      
      if (!invoiceResponse.ok) {
        console.error('Failed to delete associated invoices');
      }

      // Then delete the order
      const orderResponse = await fetch(`/orders/${orderToDelete}?mydb=`+mydb, {
        method: 'DELETE',
      });
      
      if (orderResponse.ok) {
        setOrders(orders.filter(order => order.order_id !== orderToDelete));
        toast.success('Order and associated invoices deleted successfully', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        throw new Error('Failed to delete order');
      }
    } catch (err) {
      console.error('Error deleting order:', err);
      toast.error('Failed to delete order', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      closeDeleteModal();
    }
  };

  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const formatCurrency = (amount, currency = 'USD') => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  };

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      width: '100%',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <a href="/"
            style={{
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#2980b9';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#3498db';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <span style={{ fontSize: '18px' }}>←</span>
            Home
          </a>
          
          {/* Unconfirmed Checkbox */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <input
              type="checkbox"
              id="showNotExported"
              checked={showOnlyNotExported}
              onChange={(e) => setShowOnlyNotExported(e.target.checked)}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer'
              }}
            />
            <label
              htmlFor="showNotExported"
              style={{
                fontSize: '14px',
                color: '#2c3e50',
                cursor: 'pointer',
                whiteSpace: 'nowrap'
              }}
            >
              Not Replied
            </label>
          </div>
          
          {/* Search Input */}
          <input
            type="text"
            placeholder="Search by Order ID..."
            value={searchOrderId}
            onChange={(e) => setSearchOrderId(e.target.value)}
            style={{
              padding: '8px 12px',
              border: '1px solid #dce4ec',
              borderRadius: '8px',
              fontSize: '14px',
              width: '200px'
            }}
          />
          
          {/* Clear Button */}
          {searchOrderId && (
            <button
              onClick={() => setSearchOrderId('')}
              style={{
                padding: '8px 12px',
                backgroundColor: '#95a5a6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Clear
            </button>
          )}
          {/* Date Filter Inputs */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label htmlFor="startDate" style={{ fontSize: '14px', color: '#2c3e50' }}>Start Date:</label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                padding: '6px 10px',
                border: '1px solid #dce4ec',
                borderRadius: '8px',
                fontSize: '14px',
                cursor: 'pointer',
                maxWidth: '150px'
              }}
            />
            <label htmlFor="endDate" style={{ fontSize: '14px', color: '#2c3e50' }}>End Date:</label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{
                padding: '6px 10px',
                border: '1px solid #dce4ec',
                borderRadius: '8px',
                fontSize: '14px',
                cursor: 'pointer',
                maxWidth: '150px'
              }}
            />
            {(startDate || endDate) && (
              <button
                onClick={() => {
                  setStartDate('');
                  setEndDate('');
                }}
                style={{
                  padding: '6px 12px',
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Clear Dates
              </button>
            )}
          </div>
        </div>
        
        <div style={{
          backgroundColor: '#27ae60',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Total Orders: {orders.length}
        </div>
      </div>

      <h1 style={{
        color: '#2c3e50',
        textAlign: 'center',
        marginBottom: '30px',
        fontSize: '2.5rem',
        fontWeight: '300',
        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>Orders Management</h1>

      {loading ? (
        <div style={{ padding: '20px', textAlign: 'center', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>Loading...</div>
      ) : error ? (
        <div style={{ padding: '20px', textAlign: 'center', color: '#e74c3c', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>{error}</div>
      ) : orders.length === 0 ? (
        <div style={{ padding: '20px', textAlign: 'center', color: '#7f8c8d', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>No orders found</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {(() => {
            // Group orders by order_id
            const groupedOrders = orders.reduce((acc, order) => {
              if (!acc[order.order_id]) {
                acc[order.order_id] = {
                  order_id: order.order_id,
                  client_name: order.client_name,
                  client_id: order.client_id,
                  client_tel1: order.client_tel1,
                  client_tel2: order.client_tel2,
                  client_address: order.address && order.city ? `${order.address}, ${order.city}` : order.address || order.city || null,
                  date: order.date,
                  total_price: 0,
                  notes: [],
                  items: [],
                  paymentmethod: order.paymentmethod,
                };
              }
              const quantity = order.quantity || 1;
              const unitPrice = order.total_price / quantity;
              const totalItemPrice = order.total_price;
              
              acc[order.order_id].items.push({
                id: order.id, // Include database primary key
                item_id: order.item_id, // Include item_id
                item_name: order.item_name,
                note: order.note,
                quantity: quantity,
                unit_price: unitPrice,
                total_price: totalItemPrice,
                order_state: order.order_state, // Include order_state from database
              });
              acc[order.order_id].total_price += totalItemPrice;
              if (order.note) {
                acc[order.order_id].notes.push(order.note);
              }
              return acc;
            }, {});
            let groupedOrdersArray = Object.values(groupedOrders)
              .sort((a, b) => new Date(b.date) - new Date(a.date));

            // Apply filters
            if (showOnlyNotExported) {
              groupedOrdersArray = groupedOrdersArray.filter(group => !exportedOrders.has(group.order_id));
            }

            if (searchOrderId) {
              const searchTerm = searchOrderId.toLowerCase();
              groupedOrdersArray = groupedOrdersArray.filter(group => 
                group.order_id.toString().toLowerCase().includes(searchTerm)
              );
            }

            // Date range filter
            if (startDate) {
              const start = new Date(startDate);
              groupedOrdersArray = groupedOrdersArray.filter(group => new Date(group.date) >= start);
            }
            if (endDate) {
              const end = new Date(endDate);
              // To include the entire end date day, set time to end of day
              end.setHours(23, 59, 59, 999);
              groupedOrdersArray = groupedOrdersArray.filter(group => new Date(group.date) <= end);
            }

            // Update total count display
            const filteredTotal = groupedOrdersArray.length;

            // Apply pagination
            const paginatedOrders = groupedOrdersArray.slice(
              (currentPage - 1) * ordersPerPage,
              currentPage * ordersPerPage
            );

            // Reset to first page if current page is out of bounds after filtering
            if (paginatedOrders.length === 0 && currentPage > 1) {
              setCurrentPage(1);
            }

            return paginatedOrders.map((group) => (
              <div key={group.order_id} style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                transition: 'transform 0.2s ease',
                cursor: 'pointer',
              }}
              onClick={() => openDetailsModal(group)}
              onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-2px)' }}
              onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)' }}>
                <div style={{
                  background: 'linear-gradient(135deg, #2196f3 0%, #c0c0c0 100%)',
                  padding: '15px 20px',
                  color: 'white',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.2)'
                }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(45deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%)',
                  pointerEvents: 'none'
                }}/>
                  <div style={{ fontSize: '18px', fontWeight: '600' }}>
                    Order #{group.order_id}
                  </div>
                  <div style={{ fontSize: '14px' }}>
                    {formatDate(group.date)}
                  </div>
                </div>
                <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <div style={{ fontSize: '16px', color: '#34495e', marginBottom: '5px' }}>
                      Customer: {group.client_name}
                    </div>
                    <div style={{ fontSize: '16px', color: '#34495e' }}>
                      Items:
                      <ul style={{ marginTop: '5px', paddingLeft: '20px' }}>
                        {group.items.map((item, idx) => (
                          <li key={idx}>
                            {item.item_name} - Qty: {item.quantity} × {formatCurrency(item.unit_price)} = {formatCurrency(item.total_price)}
                            {item.note && (
                              <div style={{ 
                                fontSize: '12px', 
                                color: '#7f8c8d',
                                backgroundColor: '#f8f9fa',
                                padding: '4px 8px',
                                borderRadius: '6px',
                                borderLeft: '3px solid #3498db',
                                marginTop: '2px'
                              }}>
                                Note: {item.note}
                              </div>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '18px', color: '#27ae60', fontWeight: '600' }}>
                      {formatCurrency(group.total_price)}
                    </div>
                  </div>
                </div>
                <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{
                    padding: '6px 12px',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    backgroundColor: exportedOrders.has(group.order_id) ? '#27ae60' : '#e67e22',
                    color: 'white',
                    display: 'inline-block',
                  }}>
                    {exportedOrders.has(group.order_id) ? 'Confirmed 😊' : 'Reply please'}
                  </span>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openDetailsModal(group);
                      }}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#3498db',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        transition: 'all 0.3s ease',
                      }}
                      onMouseOver={(e) => { e.target.style.backgroundColor = '#2980b9'; }}
                      onMouseOut={(e) => { e.target.style.backgroundColor = '#3498db'; }}
                    >
                      Open
                    </button>
                    {!exportedOrders.has(group.order_id) && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          openDeleteModal(group.order_id);
                        }}
                        style={{
                          width: '36px',
                          height: '36px',
                          backgroundColor: '#e74c3c',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.3s ease',
                        }}
                        onMouseOver={(e) => { 
                          e.target.style.backgroundColor = '#c0392b';
                          e.target.style.transform = 'translateY(-2px)';
                        }}
                        onMouseOut={(e) => { 
                          e.target.style.backgroundColor = '#e74c3c';
                          e.target.style.transform = 'translateY(0)';
                        }}
                        title="Delete Order"
                      >
                        <i className="fa fa-trash" style={{ fontSize: '16px' }} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ));
          })()}
        </div>
        )}

      {/* Pagination Controls */}
      {!loading && !error && orders.length > 0 && (() => {
        // Calculate filtered orders count for pagination
        const groupedOrders = orders.reduce((acc, order) => {
          if (!acc[order.order_id]) {
            acc[order.order_id] = {
              order_id: order.order_id,
              client_name: order.client_name,
              client_id: order.client_id,
              client_tel1: order.client_tel1,
              client_tel2: order.client_tel2,
              client_address: order.address && order.city ? `${order.address}, ${order.city}` : order.address || order.city || null,
              date: order.date,
              total_price: 0,
              notes: [],
              items: [],
              paymentmethod: order.paymentmethod,
            };
          }
          const quantity = order.quantity || 1;
          const unitPrice = order.total_price / quantity;
          const totalItemPrice = order.total_price;
          
          acc[order.order_id].items.push({
            id: order.id,
            item_id: order.item_id,
            item_name: order.item_name,
            note: order.note,
            quantity: quantity,
            unit_price: unitPrice,
            total_price: totalItemPrice,
            order_state: order.order_state,
          });
          acc[order.order_id].total_price += totalItemPrice;
          if (order.note) {
            acc[order.order_id].notes.push(order.note);
          }
          return acc;
        }, {});

        let groupedOrdersArray = Object.values(groupedOrders)
          .sort((a, b) => new Date(b.date) - new Date(a.date));

        // Apply filters
        if (showOnlyNotExported) {
          groupedOrdersArray = groupedOrdersArray.filter(group => !exportedOrders.has(group.order_id));
        }

        if (searchOrderId) {
          const searchTerm = searchOrderId.toLowerCase();
          groupedOrdersArray = groupedOrdersArray.filter(group => 
            group.order_id.toString().toLowerCase().includes(searchTerm)
          );
        }

        const filteredTotal = groupedOrdersArray.length;
        const totalPages = Math.ceil(filteredTotal / ordersPerPage);

        return filteredTotal > 0 ? (
          <div style={{ 
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            marginTop: '20px'
          }}>
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  padding: '8px 16px',
                  backgroundColor: currentPage === 1 ? '#e9ecef' : '#3498db',
                  color: currentPage === 1 ? '#6c757d' : 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  fontSize: '14px'
                }}
              >
                Previous
              </button>
              <span style={{ 
                display: 'flex', 
                alignItems: 'center',
                color: '#2c3e50',
                fontSize: '14px'
              }}>
                Page {currentPage} of {totalPages} ({filteredTotal} orders)
              </span>
              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage >= totalPages}
                style={{
                  padding: '8px 16px',
                  backgroundColor: currentPage >= totalPages ? '#e9ecef' : '#3498db',
                  color: currentPage >= totalPages ? '#6c757d' : 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: currentPage >= totalPages ? 'not-allowed' : 'pointer',
                  fontSize: '14px'
                }}
              >
                Next
              </button>
          </div>
        ) : null;
      })()}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '400px',
            width: '100%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            textAlign: 'center',
          }}>
            <h3 style={{ marginBottom: '20px', color: '#e74c3c' }}>Confirm Delete</h3>
            <p style={{ marginBottom: '30px' }}>Are you sure you want to delete the whole order?  </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <button
                onClick={handleDelete}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#e74c3c',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#c0392b';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#e74c3c';
                }}
              >
                Delete
              </button>
              <button
                onClick={closeDeleteModal}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#7f8c8d';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#95a5a6';
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Details Modal */}
      {showDetailsModal && selectedOrder && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '800px',
            width: '90%',
            maxHeight: '80vh',
            overflowY: 'auto',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, color: '#2c3e50' }}>Order #{selectedOrder.order_id} Details</h2>
              <button
                onClick={closeDetailsModal}
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  padding: '5px',
                  color: '#95a5a6',
                }}
              >
                ×
              </button>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Customer:</strong> {selectedOrder.client_name}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Phone 1:</strong> {selectedOrder.client_tel1 || 'N/A'}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Phone 2:</strong> {selectedOrder.client_tel2 || 'N/A'}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Address:</strong> {selectedOrder.client_address || 'N/A'}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Date:</strong> {formatDate(selectedOrder.date)}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Total Amount:</strong> {formatCurrency(selectedOrder.total_price)}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>In Stock Total:</strong> {formatCurrency(
                  selectedOrder.items
                    .filter(item => (item.order_state || orderStates[item.id] || 'pending') === 'instock')
                    .reduce((sum, item) => sum + item.total_price, 0)
                )}
              </p>
             <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Payment Method:</strong> {selectedOrder.paymentmethod || 'N/A'}
              </p>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                backgroundColor: 'white',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}>
                <thead>
                  <tr style={{
                    backgroundColor: '#f8f9fa',
                    borderBottom: '2px solid #dee2e6',
                  }}>
                    <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Item</th>
                    <th style={{ padding: '12px', textAlign: 'center', color: '#2c3e50' }}>Qty</th>
                    <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Status</th>
                    <th style={{ padding: '12px', textAlign: 'right', color: '#2c3e50' }}>Unit Price</th>
                    <th style={{ padding: '12px', textAlign: 'right', color: '#2c3e50' }}>Total</th>
                    <th style={{ padding: '12px', textAlign: 'left', color: '#2c3e50' }}>Note</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedOrder.items.map((item) => (
                    <tr key={item.id} style={{
                      borderBottom: '1px solid #dee2e6',
                    }}>
                      <td style={{ padding: '12px', color: '#2c3e50' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '2px' }}>
                            ID: {item.item_id}
                          </span>
                          <span>{item.item_name}</span>
                        </div>
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center', color: '#2c3e50', fontWeight: '500' }}>
                        {item.quantity}
                      </td>
                      <td style={{ padding: '12px' }}>
                        <select
                          value={item.order_state || orderStates[item.id] || 'pending'}
                          onChange={(e) => handleOrderStateChange(item.id, e.target.value)}
                          disabled={exportedOrders.has(selectedOrder.order_id)}
                          style={{
                            padding: '6px 12px',
                            borderRadius: '4px',
                            border: '1px solid #dce4ec',
                            backgroundColor: exportedOrders.has(selectedOrder.order_id) ? '#f5f6f7' : '#fff',
                            color: exportedOrders.has(selectedOrder.order_id) ? '#95a5a6' : '#2c3e50',
                            fontSize: '14px',
                            cursor: exportedOrders.has(selectedOrder.order_id) ? 'not-allowed' : 'pointer',
                            outline: 'none'
                          }}
                        >
                          <option value="pending">Pending</option>
                          <option value="instock">In Stock</option>
                          <option value="outofstock">Out of Stock</option>
                        </select>
                      </td>
                      <td style={{ padding: '12px', textAlign: 'right', color: '#7f8c8d' }}>
                        {formatCurrency(item.unit_price)}
                      </td>
                      <td style={{ padding: '12px', textAlign: 'right', color: '#27ae60', fontWeight: '500' }}>
                        {formatCurrency(item.total_price)}
                      </td>
                      <td style={{ padding: '12px', color: '#7f8c8d' }}>
                        {item.note || '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ 
              marginTop: '20px',
              display: 'block',
              justifyContent: 'flex-end',
              borderTop: '1px solid #dee2e6',
              paddingTop: '20px',
              gap: '10px'
            }}>
                <>
                {!exportedOrders.has(selectedOrder.order_id) && (
                  <button
                    onClick={handleExportInvoice}
                    style={{
                      padding: '12px 24px',
                      backgroundColor: '#27ae60',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = '#219a52';
                      e.target.style.transform = 'translateY(-2px)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = '#27ae60';
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    <span style={{ fontSize: '18px' }}>📄</span>
                    Confirm and Export Invoice
                  </button>
                )}

                <br/><br/>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleExportPDF();
                  }}
                  style={{
                    marginLeft: '10px',
                    padding: '12px 24px',
                    backgroundColor: '#e74c3c', // changed to red
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#c0392b'; // darker red on hover
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#e74c3c'; // revert to red
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
  


                  <span style={{ fontSize: '18px' }}>📄</span>
                   Export to PDF
                </button>

<br/> 

                {/* WhatsApp Export Button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleExportPDFAndSendWhatsApp();
                  }}
                  style={{
                    marginLeft: '10px',
                    padding: '12px 24px',
                    backgroundColor: '#25D366',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#1ebe57';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#25D366';
                    e.target.style.transform = 'translateY(0)';
                  }}
                  title="Send PDF via WhatsApp"
                >
                  <span style={{ fontSize: '18px' }}>📱</span>
                  WhatsApp
                </button>

                <br/> 
                {exportedOrders.has(selectedOrder.order_id) && (
                  <div style={{
                    padding: '12px 24px',
                    backgroundColor: '#95a5a6',
                    color: 'white',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginLeft: '10px',
                  }}>
                    <span style={{ fontSize: '18px' }}>✅</span>
                    Already Confirmed
                  </div>
                )}
                </>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Orders;
